import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode | ReactNode[];
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  height: 100%;

  @media (min-width: 768px) { 
    flex-wrap: wrap;
  }

  @media (max-width: 1023px) { 
    flex-wrap: wrap;
  }
`;

export const SectionWrapper = ({ children }: Props) => {
  return <Wrapper>{children}</Wrapper>;
};
